"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _IconButton = _interopRequireDefault(require("@eig-builder/core-ui/IconButton"));

var _wrapperContext = _interopRequireDefault(require("../context/wrapper-context"));

var _goToHelper = require("@eig-builder/core-utils/helpers/go-to-helper");

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: pointer;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  /* The padding, margin keeps the ripple effect nice */\n  margin: ", " !important;\n  padding: ", " !important;\n\n  padding-right: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  ", ";\n  color: #171818;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledIcon = (0, _styledComponents["default"])(_Icon["default"])(_templateObject(), function (props) {
  return props.hover ? 'cursor: pointer;' : '';
});
var StyledIconButton = (0, _styledComponents["default"])(_IconButton["default"])(_templateObject2(), function (props) {
  return "".concat(props.theme.spacing(2), "px");
}, function (props) {
  return "".concat(props.theme.spacing(3), "px");
}, function (props) {
  return props.paddingright;
});

var StyledBackButton = _styledComponents["default"].span(_templateObject3());

var BackButton = function BackButton(_ref) {
  var addText = _ref.addText,
      highlighted = _ref.highlighted,
      paddingRight = _ref.paddingRight,
      onClick = _ref.onClick,
      icon = _ref.icon;
  var wrapperContext = (0, _react.useContext)(_wrapperContext["default"]);

  var goBack = function goBack() {
    var currentRoute = wrapperContext.activePage;

    if (onClick) {
      onClick();
    } else if (currentRoute && !(0, _isEmpty["default"])(currentRoute.pathToLeaveFocusView)) {
      var pathToLeaveFocusView = currentRoute.pathToLeaveFocusView;
      var newRoute = typeof pathToLeaveFocusView === 'function' ? pathToLeaveFocusView(wrapperContext.history) : pathToLeaveFocusView;
      (0, _goToHelper.goToWithHistory)(wrapperContext.history, newRoute);
    } else {
      wrapperContext.history.goBack();
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledIconButton, {
    disableTouchRipple: true,
    tag: "back focus screen",
    dataElementLocation: _taggingHelper.DataElementLocations.HEADER,
    dataElementLabel: "navigation-back-button",
    dataElementId: "navigation-back-button",
    onClick: goBack,
    paddingright: paddingRight
  }, /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    highlighted: highlighted,
    icon: icon
  })), addText && /*#__PURE__*/_react["default"].createElement(StyledBackButton, {
    onClick: goBack
  }, "Back"));
};

BackButton.propTypes = {
  addText: _propTypes["default"].string,
  highlighted: _propTypes["default"].bool,
  paddingRight: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  icon: _propTypes["default"].oneOf(['arrow_back', 'home'])
};
BackButton.defaultProps = {
  icon: 'arrow_back'
};
var _default = BackButton;
exports["default"] = _default;